import { RESOURCES } from '@shared/Resources/types';

export const EXCLUDED_TYPES = {
  MEDIA: RESOURCES.MEDIA,
  MENTOR_FORM: RESOURCES.MENTOR_FORM,
  STIMULUS: RESOURCES.STIMULUS,
  SPEECH_GOAL: RESOURCES.SPEECH_GOAL,
}
